if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.panelWrap = this.querySelector('.pp-product-tabs__panels');
        if (!this.tabs.length || !this.panels.length || !this.panelWrap) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.tabTarget));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      connectedCallback() {
        const activePanel = this.querySelector('.pp-product-tabs__panel.is-active');
        if (activePanel) {
          this.panelWrap.style.height = `${activePanel.offsetHeight}px`;
          requestAnimationFrame(() => {
            this.panelWrap.style.height = 'auto';
          });
        }
      }

      onKeydown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        this.tabs[nextIndex].focus();
        this.activate(this.tabs[nextIndex].dataset.tabTarget);
      }

      activate(tabName) {
        const currentPanel = this.panels.find((panel) => panel.classList.contains('is-active'));
        const nextPanel = this.panels.find((panel) => panel.dataset.tabPanel === tabName);
        if (!nextPanel || nextPanel === currentPanel) return;

        const startHeight = currentPanel ? currentPanel.offsetHeight : this.panelWrap.offsetHeight;
        this.panelWrap.style.height = `${startHeight}px`;
        this.panelWrap.style.overflow = 'hidden';

        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.tabTarget === tabName;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        });

        if (currentPanel) {
          currentPanel.classList.remove('is-active');
          currentPanel.hidden = true;
        }

        nextPanel.hidden = false;
        nextPanel.classList.add('is-active');

        requestAnimationFrame(() => {
          const endHeight = nextPanel.offsetHeight;
          this.panelWrap.style.height = `${endHeight}px`;
        });

        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => {
          this.panelWrap.style.height = 'auto';
          this.panelWrap.style.overflow = '';
        }, 430);
      }
    }
  );
}
(() => {
  const selector = '.pp-product-app-tabs .station-tabs-tabset';

  const initializeSlider = (tabset) => {
    if (tabset.dataset.ppSliderReady === 'true') return;

    const titles = Array.from(tabset.children).filter((child) => child.classList.contains('station-tabs-tabtitle'));
    if (titles.length < 2) return;

    tabset.dataset.ppSliderReady = 'true';

    const root = tabset.closest('.pp-product-app-tabs');
    const controls = document.createElement('div');
    const rail = document.createElement('div');
    const previousButton = document.createElement('button');
    const nextButton = document.createElement('button');

    controls.className = 'pp-station-tabs-slider';
    rail.className = 'pp-station-tabs-slider__rail';
    rail.setAttribute('role', 'group');
    rail.setAttribute('aria-label', root?.dataset.sliderLabel || 'Slider');

    previousButton.type = 'button';
    previousButton.className = 'pp-station-tabs-slider__button pp-station-tabs-slider__button--previous';
    previousButton.setAttribute('aria-label', root?.dataset.sliderPrevious || 'Slide left');

    nextButton.type = 'button';
    nextButton.className = 'pp-station-tabs-slider__button pp-station-tabs-slider__button--next';
    nextButton.setAttribute('aria-label', root?.dataset.sliderNext || 'Slide right');

    titles.forEach((title) => rail.appendChild(title));
    controls.append(previousButton, rail, nextButton);
    tabset.insertBefore(controls, tabset.firstChild);

    const updateControls = () => {
      const maximumScroll = Math.max(rail.scrollWidth - rail.clientWidth, 0);
      const isScrollable = rail.scrollWidth > controls.clientWidth + 2;
      controls.classList.toggle('is-scrollable', isScrollable);
      previousButton.disabled = !isScrollable || rail.scrollLeft <= 2;
      nextButton.disabled = !isScrollable || rail.scrollLeft >= maximumScroll - 2;
    };

    const scrollRail = (direction) => {
      rail.scrollBy({ left: direction * Math.max(rail.clientWidth * 0.7, 180), behavior: 'smooth' });
    };

    previousButton.addEventListener('click', () => scrollRail(-1));
    nextButton.addEventListener('click', () => scrollRail(1));
    rail.addEventListener('scroll', updateControls, { passive: true });

    titles.forEach((title) => {
      title.addEventListener('click', () => {
        title.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    });

    if ('ResizeObserver' in window) {
      tabset.ppResizeObserver = new ResizeObserver(updateControls);
      tabset.ppResizeObserver.observe(rail);
    } else {
      window.addEventListener('resize', updateControls);
    }

    requestAnimationFrame(updateControls);
  };

  const initializeSliders = (container = document) => {
    container.querySelectorAll(selector).forEach(initializeSlider);
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        const closestTabset = node.closest(selector);
        if (closestTabset) initializeSlider(closestTabset);
        node.querySelectorAll(selector).forEach(initializeSlider);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeSliders(), { once: true });
  } else {
    initializeSliders();
  }

  document.addEventListener('shopify:section:load', (event) => initializeSliders(event.target));
})();
